module.exports = __webpack_public_path__ + "img/M361.72286189.png";